import React from 'react';
import PropTypes from 'prop-types';
import GreetingSection from './GreetingSection';
import HealthSummarySection from './HealthSummarySection';
import TestResultsSection from './TestResultsSection';
import RecommendationsSection from './RecommendationsSection';
import DoctorQuestionsSection from './DoctorQuestionsSection';
import SpecialistsSection from './SpecialistsSection';
import InteractiveQASection from './InteractiveQASection';
import { parseAnalysis, getStatusColor, getStatusIcon } from '../utils/labReportUtils';

function Insights({ data, extractedText }) {
  if (!data) {
    return (
      <div className="insights">
        <div className="no-insights">
          <p>📋 No insights available. Please upload a lab report to get started.</p>
        </div>
      </div>
    );
  }

  const sections = parseAnalysis(data);

  return (
    <div className="insights">
      <GreetingSection greeting={sections.greeting} />
      
      <HealthSummarySection 
        healthSummary={sections.healthSummary}
        deficiencies={sections.deficiencies}
      />
      
      <TestResultsSection 
        testResults={sections.testResults}
        getStatusColor={getStatusColor}
        getStatusIcon={getStatusIcon}
      />
      
      <RecommendationsSection recommendations={sections.recommendations} />
      
      <DoctorQuestionsSection doctorQuestions={sections.doctorQuestions} />
      
      <SpecialistsSection specialists={sections.specialists} />
      
      <InteractiveQASection 
        testResults={sections.testResults}
        extractedText={extractedText}
      />

      <div className="disclaimer-section">
        <p className="disclaimer">
          ⚠️ <em>This analysis is for educational purposes only and is not medical advice. Always consult with your healthcare provider for medical decisions and treatment.</em>
        </p>
      </div>
    </div>
  );
}

Insights.propTypes = {
  data: PropTypes.string,
  extractedText: PropTypes.string,
};

export default Insights;